export enum CountryBlockType {
  Hard = "Hard",
  Soft = "Soft"
}